export default __webpack_public_path__ + "static/media/Display of Affection.38f364bf.png";